import { render, staticRenderFns } from "./HumanChart.vue?vue&type=template&id=480ebaf9&scoped=true&"
import script from "./HumanChart.vue?vue&type=script&lang=ts&"
export * from "./HumanChart.vue?vue&type=script&lang=ts&"
import style0 from "./HumanChart.vue?vue&type=style&index=0&id=480ebaf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ebaf9",
  null
  
)

export default component.exports